import React, { useRef, useState } from 'react';
import { AnimatePresence, motion, useMotionValue, useReducedMotion, useSpring } from 'framer-motion';
import { ventureGatherings } from '../../../data/ventureStory';
const ease = [0.22, 1, 0.36, 1] as const;

// An index of past seasons; hovering a row brings its photograph up beside the cursor
export function GatheringsIndex() {
  const reduce = useReducedMotion();
  const ref = useRef<HTMLElement>(null);
  const [active, setActive] = useState<number | null>(null);
  const x = useMotionValue(0);
  const y = useMotionValue(0);
  const sx = useSpring(x, {
    stiffness: 120,
    damping: 22
  });
  const sy = useSpring(y, {
    stiffness: 120,
    damping: 22
  });
  const onMove = (e: React.PointerEvent) => {
    const r = ref.current?.getBoundingClientRect();
    if (!r) return;
    x.set(e.clientX - r.left);
    y.set(e.clientY - r.top);
  };
  return <section ref={ref} onPointerMove={onMove} aria-labelledby="gatherings-heading" className="relative px-6 py-24 md:px-16 md:py-40" data-id="element-1285" data-mp="3n5tzmkksyusy">
      <div className="mx-auto max-w-[1440px]" data-id="element-1286" data-mp="1imwz0ykjh2em">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between" data-id="element-1287" data-mp="1ijsqjp01jki5">
          <motion.h2 id="gatherings-heading" initial={{
          opacity: 0,
          y: reduce ? 0 : 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.6
        }} transition={{
          duration: 1.1,
          ease
        }} className="font-editorial text-[44px] leading-[48px] tracking-[-0.015em] md:text-[64px] md:leading-[66px]" data-id="element-1288" data-mp="1nivt92sjtemy">
            {ventureGatherings.heading}
          </motion.h2>
          <p className="max-w-[340px] text-[15px] font-light leading-[24px] text-paper/65" data-id="element-1289" data-mp="pxzj323svhp1">{ventureGatherings.note}</p>
        </div>

        <ul className="mt-14 border-t border-paper/15" onPointerLeave={() => setActive(null)} data-id="element-1290" data-mp="uwki4y7bfvbw">
          {ventureGatherings.items.map((item, i) => {
          const dim = active !== null && active !== i;
          return <motion.li key={item.place} initial={{
            opacity: 0,
            y: reduce ? 0 : 24
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.6
          }} transition={{
            duration: 1,
            ease,
            delay: i * 0.06
          }} onPointerEnter={() => setActive(i)} className="border-b border-paper/15" data-id="element-1291" data-mp="2nks66xk0c9pc" data-mpi={i}>
                <div className={`grid grid-cols-[72px_1fr] items-center gap-5 py-6 transition-[opacity,transform] duration-500 ease-luxe md:grid-cols-[1fr_1.2fr_auto] md:gap-10 md:py-8 ${dim ? 'opacity-35' : 'opacity-100'} ${active === i ? 'md:translate-x-4' : ''}`} data-id="element-1292" data-mp="36jecqryamt0n">
                  <img src={item.image} alt="" className="h-[72px] w-[72px] object-cover md:hidden" aria-hidden="true" data-id="element-1293" data-mp="2sjbtb1ac7rja" />
                  <div className="md:contents" data-id="element-1294" data-mp="1l474ngte8267">
                    <p className="font-editorial text-[34px] leading-none tracking-[-0.01em] md:text-[56px]" data-id="element-1295" data-mp="1h4gftinffw4b">{item.place}</p>
                    <p className="mt-2 text-[16px] font-light text-paper/75 md:mt-0 md:text-[18px]" data-id="element-1296" data-mp="3stmnpc97wfzs">{item.title}</p>
                    <p className="hidden text-[14px] font-light text-paper/55 md:block" data-id="element-1297" data-mp="oivrvm6b5qf">{item.season}</p>
                  </div>
                </div>
              </motion.li>;
        })}
        </ul>
      </div>

      {/* Floating preview */}
      <motion.div style={{
      x: sx,
      y: sy
    }} className="pointer-events-none absolute left-0 top-0 z-[2] hidden md:block" aria-hidden="true" data-id="element-1298" data-mp="fdyf4qjdk8w3">
        <AnimatePresence data-id="element-1299" data-mp="kaf5zshyl1cv">
          {active !== null && <motion.img key={active} src={ventureGatherings.items[active].image} alt="" initial={{
          opacity: 0,
          scale: 0.96,
          rotate: -2
        }} animate={{
          opacity: 1,
          scale: 1,
          rotate: 0
        }} exit={{
          opacity: 0,
          scale: 0.96
        }} transition={{
          duration: 0.3,
          ease
        }} className="absolute left-10 top-[-150px] h-[300px] w-[240px] object-cover" data-id="element-1300" data-mp="odlk1mbbbwtw" />}
        </AnimatePresence>
      </motion.div>
    </section>;
}